import { useEffect, useState } from 'react';
import { get, post } from '../../../Services/api'
import BMIChart from './Chart';
import './bmi.css'
import yyyy_mm_dd_date_format from '../../../Utility/yyyy_mm_dd_date_format';

function AnalyticsBMI({ currentUser }) {
    const today = yyyy_mm_dd_date_format({})

    const [userHealthStats, setUserHealthStat] = useState([]);
    const [bmi, setBMI] = useState(0)
    const [unit, setUnit] = useState()

    useEffect(() => {
        // Body composition
        get_user_body_composition()
        // BMI Stats
        // get_user_health_stat()
    }, [])


    function bmi_description_generator(bmi) {
        if (bmi < 18.5) {
            return "Underweight"
        } else if (bmi <= 24.9) {
            return "Healthy Weight"
        } else if (bmi <= 29.9) {
            return "Overweight"
        } else {
            return "Obese"
        }
    }

    async function get_user_body_composition() {
        const result = []

        const resp = await get("/api/analytics/get-body-composition-on-day", {
            user_id: currentUser.uid,
            date: today
        })

        // BMI
        setBMI(resp.bmi)

        // Muscle Mass
        result.push({
            value: parseFloat(resp.lean_body_mass).toFixed(1),
            label: 'Muscle (' + resp.unit + ')'
        })
        // Water Mass
        result.push({
            value: parseFloat(resp.body_water_mass).toFixed(1),
            label: 'Water (' + resp.unit + ')'
        })
        // Fat Percentage
        result.push({
            value: fatPercentageToMass(resp, resp.weight).toFixed(1),
            percentage: parseFloat(resp.body_fat_percentage).toFixed(1),
            label: 'Fat (' + resp.unit + ')'
        })

        setUserHealthStat(result)
        // set unit
        setUnit(resp.unit)
    }

    function fatPercentageToMass(data, weight) {
        const fat_percentage = parseFloat(data.body_fat_percentage) / 100
        return weight * fat_percentage
    }

    return (
        <div className='component_padding black'>
            <div className='dashboard-intake-overview-heading flex align_center justify_space_between'>
                <h4 className='font_family_ovo no_margin'>BMI Analytics</h4>
            </div>

            <div className='component_heading_separating_line'></div>

            <div className='analytics-bmi-chart-div'>
                <BMIChart details={userHealthStats} />
                <div className='analytics-bmi-chart-bmi-div text_align_center'>
                    <p className='font_size_68 font_family_ovo gray_scale_1'>{bmi}</p>
                    <p className='font_weight_600 font_size_20 gray_scale_3'>BMI</p>
                </div>
            </div>

            <div className='analytics-bmi-detail-breakdown-div flex flex_column gap_12'>
                <div className='flex justify_space_between align_center'>
                    <div className='flex gap_8 align_center'>
                        <div className='analytics-bmi-muscle-mass-icon'></div>
                        <p className='font_weight_600 gray_scale_2'>Muscle Mass</p>
                    </div>
                    <p className='font_weight_600 gray_scale_2'>{userHealthStats[0]?.value + ' ' + unit}</p>
                </div>
                <div className='flex justify_space_between align_center'>
                    <div className='flex gap_8 align_center'>
                        <div className='analytics-bmi-water-mass-icon'></div>
                        <p className='font_weight_600 gray_scale_2'>Water Mass</p>
                    </div>
                    <p className='font_weight_600 gray_scale_2'>{userHealthStats[1]?.value + ' ' + unit}</p>
                </div>
                <div className='flex justify_space_between align_center'>
                    <div className='flex gap_8 align_center'>
                        <div className='analytics-bmi-fat-percentage-icon'></div>
                        <p className='font_weight_600 gray_scale_2'>Body Fat</p>
                    </div>
                    <p className='font_weight_600 gray_scale_2'>{userHealthStats[2]?.percentage} %</p>
                </div>
            </div>
        </div>
    );
}


export default AnalyticsBMI;